module.exports = __webpack_public_path__ + "img/shuxian1111.2095456d.png";